export const isDefaultDate = '0001-01-01T00:00:00Z';
export const DEFAULT_THEME = 'theme-white';
export const BLOG_TEMPLATE_ID = '1f627e91-79f2-4ce5-a18a-bf33972b2072';
export const GENERAL_PAGE_T2_TEMPLATE_ID = 'd2b65608-e58c-4e89-9a58-25fd1474c762';
export const PROVIDER_TEMPLATE_ID = '6de30456-2d7d-4d28-bf1b-2b2b8aa42e62';
export const PROVIDER_PRIMARY_CARE_TEMPLATE_ID = '69c01af6-a958-4b60-b548-21b26f009590';
export const PROVIDER_TYPE_CMG_TEMPLATE_ID = '2a19dd0a-59cc-4e99-94fc-f7a78921ef73';

export const providerImportConstants = {
  tenantRootPath: '/sitecore/content/CW',
  specialtiesRootPath: 'Settings/MDStaff/Specialties',
  schedulingTypesRootPath: 'Settings/MDStaff/Scheduling Types',
  providersRootPath: 'Home/Providers',
  lookUpsRootPath: 'Global/MDStaff/Lookups',
  sitecoreSpecialtyTemplateId: '{4600FF49-3190-42A9-A736-289124E9A0A3}',
  sitecoreProviderBranchTemplateId: '{F7AD0AF0-984A-4C49-947D-5C71F276C184}',
  sitecoreProviderTemplateId: '{6DE30456-2D7D-4D28-BF1B-2B2B8AA42E62}',
  sitecoreAlphabetFolderTemplateId: '{A855A604-C636-4D4B-9E54-C999403C7461}',
  sitecoreLookUpTemplateId: '{0FCE0A23-85EA-4C6A-8B9A-F84418BF6776}',
};
